import { useHotkeys } from "@mantine/hooks";
import { useMapView } from "../../hooks/useMapView";

export default function GVMapView({ isHybridView }) {
    const { fileIndex, selectNewFile, currentMapFile } = useMapView();

    useHotkeys([
        ["Period", () => selectNewFile(fileIndex + 1)],
        ["Comma", () => selectNewFile(fileIndex - 1)],
    ]);

    return (
        <MapViewWrapper isHybridView={isHybridView}>
            {currentMapFile?.preview && (
                <img
                    src={currentMapFile?.preview}
                    key={currentMapFile?.id}
                    alt="Tract Map"
                    style={{ height: "100%", width: "100%" }}
                    className="object-contain object-center"
                />
            )}
        </MapViewWrapper>
    );
}

const MapViewWrapper = ({ isHybridView, children }) => {
    if (!isHybridView) {
        return (
            <div
                className="w-screen h-screen"
                style={{
                    maxHeight: "calc(100vh - 152px)",
                }}
            >
                {children}
            </div>
        );
    }
    return <>{children}</>;
};
